export const CATEGORY_LIST = [
  { id: 1, name: "Social Platforms" },
  { id: 2, name: "Messaging Apps" },
  { id: 3, name: "Professional Networks" },
  { id: 4, name: "Job Boards" },
  { id: 5, name: "Freelancing Platforms" },
  { id: 6, name: "Online Learning" },
  { id: 7, name: "Research & Academia" },
  { id: 8, name: "Language Learning" },
  { id: 9, name: "Global News" },
  { id: 10, name: "Local & Regional News" },
  { id: 11, name: "Tech News" },
  { id: 12, name: "Pornography" },
  { id: 13, name: "Adult Stores" },
  { id: 14, name: "General Retail" },
  { id: 15, name: "Fashion & Apparel" },
  { id: 16, name: "Food & Grocery" },
  { id: 17, name: "Electronics" },
  { id: 18, name: "Online Casinos" },
  { id: 19, name: "Sports Betting" },
  { id: 20, name: "Video Streaming" },
  { id: 21, name: "Music Streaming" },
  { id: 22, name: "Game Streaming" },
  { id: 23, name: "General Discussion" },
  { id: 24, name: "Tech & Developer Forums" },
  { id: 25, name: "Phishing Sites" },
  { id: 26, name: "Malicious Downloads" },
  { id: 27, name: "VPN Providers" },
  { id: 28, name: "Proxy Lists" },
  { id: 29, name: "Official Software" },
  { id: 30, name: "File Sharing" },
  { id: 31, name: "Webmail" },
  { id: 32, name: "File Storage" },
  { id: 33, name: "Collaboration" },
  { id: 34, name: "Online Banking" },
  { id: 35, name: "Payment Services" },
  { id: 36, name: "Investment & Trading" },
  { id: 37, name: "Cryptocurrency & Blockchain" },
  { id: 38, name: "National Portals" },
  { id: 39, name: "Local Services" },
  { id: 40, name: "Health Information" },
  { id: 41, name: "Fitness & Wellness" },
  { id: 42, name: "Airlines" },
  { id: 43, name: "Ride Sharing" },
  { id: 44, name: "Booking & Hotels" },
  { id: 45, name: "Tech Companies" },
  { id: 46, name: "Developer Resources" },
  { id: 47, name: "Gadgets & Reviews" },
  { id: 48, name: "Dating Apps" },
  { id: 49, name: "Adult Chat Rooms" },
  { id: 50, name: "Online Games" },
  { id: 51, name: "Game Marketplaces" },
  { id: 52, name: "Property Listings" },
  { id: 53, name: "Rentals & Short Stays" },
  { id: 54, name: "Green Initiatives" },
  { id: 55, name: "Religious Organizations" },
  { id: 56, name: "Journals & Databases" },
  { id: 57, name: "Recipes & Blogs" },
  { id: 58, name: "Sports News & Scores" },
  { id: 59, name: "Children's Entertainment" },
  { id: 60, name: "Car Brands & Dealers" },
  { id: 61, name: "Charity & Aid" },
  { id: 62, name: "Web Search Engines" },
  { id: 63, name: "Miscellaneous" },
];
